import { Logger } from './Logger';
import VatsAPI from './VatsAPI';

export const redirectRetiredLocation = async (location: string) => {
    let redirectionUrl = null;

    if (location) {
        try {
            redirectionUrl = (await VatsAPI.get(`${location}/Citations/LocationRedirect`)).data;
        }
        catch (e) {
            Logger.Error('Error getting redirection URL for location', location);
        }
    }

    if (redirectionUrl) {
        window.location.replace(redirectionUrl);
    }
};
